/* eslint-disable @typescript-eslint/ban-types */
export type Disposer = () => void;

export type HookFn<T> = (changeSet?: Set<keyof T>) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Subscribable<T extends object | Record<any, any>> {
	subscribe(event: HookFn<T>): Disposer;
}

export const PRESENTATION_DEBUG_REF = '__cortex_presentation_debug_ref__';

export const PRESENTATION_DEBUG_HOOK = '__cortex_presentation_debug_hook__';
